import { templateActionTypes, userActionTypes } from '../actions/types';
import { templateService } from '../services';
import _ from 'lodash';

const normalizeTags = tags =>
  Array.isArray(tags) ? tags.filter(tag => typeof tag === 'string' && tag.trim()) : [];

const resetState = () => {
  return dispatch => dispatch({ type: templateActionTypes.RESET_STATE });
};

const search = (query, clear, tag) => {
  return (dispatch, getState) => {
    dispatch(request(tag));

    const publicRequest = getState().authentication.user && getState().authentication.user.userId ? false : true;
    let skip;
    let limit;

    if (tag) {
      skip = getState().template[`${tag}Skip`];
      limit = 15; // getState().template[`${tag}Skip`];
    } else {
      skip = getState().template.templateSkip;
      limit = getState().template.templateLimit;
    }

    query = _.omitBy(query, value => _.isNil(value) || (_.isString(value) && _.isEmpty(value)));

    if (clear || skip === null) {
      skip = 0;
    } else {
      skip = skip + limit;
    }

    templateService
      .findAll(
        {
          ...query,
          skip: query.skip || skip,
          limit: query.limit || limit,
        },
        publicRequest,
      )
      .then(
        templates => {
          if (_.has(templates, '[0].templates')) {
            templates = templates.map(templateGroup => {
              templateGroup.templates = templateGroup.templates.map((template, index) => {
                const extension = template.extension || 'png';
                return {
                  src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.${extension}`,
                  width: _.get(template, 'size.width', 1080),
                  height: _.get(template, 'size.height', 1080),
                  key: index.toString(),
                  type: 'Template',
                  data: {
                    index,
                    id: template._id,
                    name: template.name,
                    tags: normalizeTags(template.tags),
                    categories: template.categories,
                    size: template.size,
                    pages: template.pages || [],
                    tempId: template.tempId,
                    price: template.price,
                    extension,
                  },
                };
              });
              return templateGroup;
            });
          } else {
            const offset = clear ? 0 : _.get(getState().template.templates, 'length', 0);
            templates = templates.map((template, index) => {
              const extension = template.extension || 'png';
              return {
                src: `${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template._id}/thumbnail.${extension}`,
                width: template.size ? template.size.width : 1080,
                height: template.size ? template.size.height : 1080,
                key: (offset + index).toString(),
                type: 'Template',
                data: {
                  index: (offset + index).toString(),
                  id: template._id,
                  name: template.name,
                  tags: normalizeTags(template.tags),
                  categories: template.categories,
                  size: template.size,
                  pages: template.pages || [],
                  tempId: template.tempId,
                  price: template.price,
                  extension,
                },
              };
            });
          }
          dispatch(success(templates, skip, limit, clear, tag));
        },
        error => {
          dispatch(
            _refreshTokenOnFailure(
              error,
              templateActionTypes.SEARCH_FAILURE,
              getState().authentication.pendingRefreshingToken,
              tag,
            ),
          );
        },
      );
  };

  function request(tag) {
    return { type: templateActionTypes.SEARCH_REQUEST, tag };
  }
  function success(templates, skip, limit, clear, tag) {
    return { type: templateActionTypes.SEARCH_SUCCESS, templates, skip, limit, clear, tag };
  }
};

const selectTemplate = templateId => {
  return { type: templateActionTypes.SELECT_TEMPLATE, templateId };
};

const getAllCategories = () => {
  return (dispatch, getState) => {
    dispatch(request());

    templateService.findAllCategories().then(
      categories => {
        dispatch(success(categories));
      },
      error => {
        dispatch(
          _refreshTokenOnFailure(
            error,
            templateActionTypes.GET_ALL_CATEGORIES_FAILURE,
            getState().authentication.pendingRefreshingToken,
          ),
        );
      },
    );
  };

  function request() {
    return { type: templateActionTypes.GET_ALL_CATEGORIES_REQUEST };
  }
  function success(categories) {
    return {
      type: templateActionTypes.GET_ALL_CATEGORIES_SUCCESS,
      categories,
    };
  }
};

const getStatistics = latest => {
  return (dispatch, getState) => {
    dispatch(request());

    templateService.getStatistics(latest).then(
      statistics => {
        const templates = statistics.reduce((acc, template) => {
          acc[template._id] = template.count;
          return acc;
        }, {});
        dispatch(success(templates));
      },
      error => {
        // dispatch(error);
      },
    );
  };

  function request() {
    if (latest) {
      return { type: templateActionTypes.STATISTIC_LATEST_REQUEST };
    } else {
      return { type: templateActionTypes.STATISTIC_REQUEST };
    }
  }
  function success(templates) {
    if (latest) {
      return {
        type: templateActionTypes.STATISTIC_LATEST_SUCCESS,
        templates,
      };
    } else {
      return {
        type: templateActionTypes.STATISTIC_SUCCESS,
        templates,
      };
    }
  }
};

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken, tag) => {
  if (error.error === 'jwt expired') {
    if (pendingRefreshToken) {
      return {
        type: userActionTypes.PENDING_REFRESH_TOKEN,
        error,
      };
    } else {
      return { type: userActionTypes.INVALID_TOKEN, error };
    }
  } else {
    return { type: failureAction, error, tag };
  }
};

export const templateActions = {
  resetState,
  search,
  selectTemplate,
  getAllCategories,
  getStatistics,
};
